import React from 'react';
import { Analytics } from "@vercel/analytics/react";
import { Header, Footer } from "./LandingPage";
import SEO from './common/SEO';
import LegalDocument from './common/LegalDocument';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col relative">
      <SEO path="/terms-of-service" noindex />
      <Header />
      <main className="flex-1 pt-32">
        <LegalDocument kind="terms" />
      </main>
      <Footer />
      <Analytics />
    </div>
  );
};

export default TermsOfServicePage;
